import { Injectable, inject } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
//import { map } from 'rxjs/internal/operators/map';
//import { catchError, Observable, of } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    private router = inject(Router);
    private authService = inject(AuthenticationService);


    canActivate() {
        console.log('AuthGuard: Checking authentication status');
        if (this.authService.isLoggedIn) {
            return true;
        } 
        this.router.navigate(['/']);
        return false;
    } 
  
}